<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="m18.424 9.287.96-4.065c.184-.785 0-1.594-.492-2.229A2.616 2.616 0 0 0 16.838 2H7.706a2.59 2.59 0 0 0-2.053.993 2.61 2.61 0 0 0-.493 2.229l.96 4.065A8.26 8.26 0 0 0 4 14.797a8.227 8.227 0 0 0 3.982 7.078l.2.125h8.189l.2-.125a8.227 8.227 0 0 0 3.982-7.079c0-2.12-.81-4.048-2.12-5.509h-.009Zm-.66-4.449-.75 3.189a8.213 8.213 0 0 0-4.742-1.503c-1.77 0-3.397.56-4.741 1.503L6.78 4.838a.972.972 0 0 1 .175-.81.954.954 0 0 1 .743-.359h9.132c.292 0 .567.134.743.36.183.225.25.525.183.81h.009Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
